import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';

import { cartKey, importCartOptions } from '@lib/api/options/cart';
import { MutationCallbackOptions } from '@lib/api/options/types';
import { CartItemInput } from '@lib/types';

export const useImportCart = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();
  const { mutateAsync: execute, isPending } = useMutation(importCartOptions());

  const onImportCart = (
    items: CartItemInput[],
    options?: MutationCallbackOptions<Awaited<ReturnType<typeof execute>>>,
  ) =>
    execute(items, {
      onSuccess: (result) => {
        queryClient
          .invalidateQueries({ queryKey: cartKey })
          .catch(() => undefined);
        options?.onCompleted?.(result);
      },
      onError: (error) => {
        message.warning('Alguns itens antigos não puderam ser importados.');
        options?.onError?.(error);
      },
    });

  return { importCart: onImportCart, importingCart: isPending };
};
